import licenseModule from '../../license.module';

export default licenseModule.component('licenseManagePerpetualId', {
    template: require('./licenseManagePerpetualId.component.html'),
    controller: ['entitlementConstants', licenseManagePerpetualIdComponent],
    bindings: {
        summaryDeviceIdTotal: '<',
        summaryPremiumUserIdTotal: '<',
        summaryDeviceIdUsage: '<',
        summaryPremiumUserIdUsage: '<',
        instanceMaxDevices: '<',
        instanceMaxUsers: '<',
        licenseMaxUsers: '<',
        licenseMaxDevices: '<',
        licenseSymmetric: '<',
        licenseReallocated: '<',
        onlyPerpetual: '<',
        instanceName: '<',
        callback: '&'
    }
});

function licenseManagePerpetualIdComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;
    vm.platformUserLabel = entitlementConstants.platformUser;

    vm.min = 1;
    vm.changes = function() {
        var value = {
            license: {
                maxUsers: vm.licenseMaxUsers,
                maxDevices: vm.licenseMaxDevices
            },
            eula: vm.eula
        };
        vm.callback({ value: value });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-manage-perpetual-id/licenseManagePerpetualId.component.js